import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";
import { propertyUnits } from "../../../utils/Helper";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

// Progress Bar Component
const UploadProgressBar = ({ file, progress, status, onRemove }) => {
  return (
    <div className="upload-progress-item mb-2 p-2 border rounded">
      <div className="d-flex align-items-center justify-content-between">
        <div className="flex-grow-1 me-2">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <small
              className="file-name text-truncate"
              style={{ maxWidth: "150px" }}
            >
              {file.name}
            </small>
            <div className="d-flex align-items-center">
              {status === "completed" ? (
                <span
                  className="text-success me-2"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  ✓
                </span>
              ) : (
                <small className="text-muted me-2">{progress}%</small>
              )}
            </div>
          </div>
          {/* Progress bar removed - only showing percentage */}
        </div>
        {(status === "completed" || status === "error") && (
          <button
            type="button"
            className="btn btn-sm btn-danger ms-2"
            onClick={onRemove}
            style={{ width: "24px", height: "24px", padding: "0" }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

function AddProperty() {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [propertyType, setPropertyType] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [cities, setCities] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [facings, setFacings] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedLocality, setSelectedLocality] = useState("");
  const [selectedFacing, setSelectedFacing] = useState("");
  const [address, setAddress] = useState("");
  const [area, setArea] = useState("");
  const [unit, setUnit] = useState("");
  const [bhk, setBhk] = useState("");
  const [floor, setFloor] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [price, setPrice] = useState("");
  const [priceUnit, setPriceUnit] = useState("");
  const [images, setImages] = useState([]);
  const [features, setFeatures] = useState([]);
  const [featureInput, setFeatureInput] = useState("");
  const [remarks, setRemarks] = useState("");
  const [startDate, setStartDate] = useState("");
  const [locationUrl, setLocationUrl] = useState("");
  const [chosen, setChosen] = useState("");
  const navigate = useNavigate();

  // New states for upload progress
  const [uploadQueue, setUploadQueue] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const [salesStaff, setSalesStaff] = useState([]);
  const [surveyStaff, setSurveyStaff] = useState([]);
  const [telecallingStaff, setTelecallingStaff] = useState([]);
  const [dataentryStaff, setataentryStaff] = useState([]);
  const [surveyorId, setSurveyorId] = useState("");
  const [salesPersonId, setSalesPersonId] = useState("");
  const [telecallerId, setTelecallerId] = useState("");
  const [propertyFor, setPropertyFor] = useState("");
  const [propertyAge, setPropertyAge] = useState("");
  const [propertyName, setPropertyName] = useState("");
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [apartments, setApartments] = useState([]);

  // New state for contact type
  const [contactType, setContactType] = useState("");

  // Fetch Staffs
  const fetchAllStaff = async () => {
    try {
      const res = await HomeService.getStaffs();
      if (res?.data) {
        setSalesStaff(
          res?.data.filter(
            (item) => item.role === "sales" && item?.city?._id === selectedCity,
          ),
        );
        setTelecallingStaff(
          res?.data.filter(
            (item) =>
              item.role === "telecalling" && item?.city?._id === selectedCity,
          ),
        );
        setSurveyStaff(
          res?.data.filter(
            (item) =>
              item.role === "survey" && item?.city?._id === selectedCity,
          ),
        );
        setataentryStaff(
          res?.data.filter(
            (item) =>
              item.role === "data entry" && item?.city?._id === selectedCity,
          ),
        );
      }
    } catch (error) {
      console.error("Error fetching staffs:", error);
    }
  };

  // Fetch localities
  const fetchLocalities = async () => {
    try {
      const res = await HomeService.getLocalities();
      if (res?.status) {
        setLocalities(
          res.data.filter((item) => item?.city?._id === selectedCity),
        );
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  // Fetch Apartments
  const fetchApartments = async () => {
    try {
      const res = await HomeService.getApartment();
      if (res?.data) {
        setApartments(
          res.data.filter(
            (item) =>
              item?.city?._id === selectedCity &&
              item?.locality?._id === selectedLocality,
          ),
        );
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  useEffect(() => {
    fetchAllStaff();
    fetchLocalities();
    fetchApartments();
  }, [selectedCity]);

  useEffect(() => {
    fetchApartments();
  }, [selectedLocality]);

  useEffect(() => {
    async function fetchPropertyTypes() {
      try {
        const res = await HomeService.getPropertyTypes();
        if (res?.data) {
          setPropertyType(res.data);
        }
      } catch (error) {
        console.error("Error fetching property types:", error);
      }
    }

    async function fetchCities() {
      try {
        const res = await HomeService.getCities();
        if (res?.data) {
          setCities(res.data);
          if (userCity) {
            setCities([res.data.find((item) => item._id === userCity)]);
          }
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    async function fetchFacings() {
      try {
        const res = await HomeService.getFacings();
        if (res?.data) {
          setFacings(res.data);
        }
      } catch (error) {
        console.error("Error fetching facings:", error);
      }
    }

    fetchPropertyTypes();
    fetchCities();
    fetchFacings();
  }, []);

  // Handle contact type change
  const handleContactTypeChange = (type) => {
    setContactType(type);
  };

  // Get the dynamic label for the name field based on contact type
  const getNameFieldLabel = () => {
    switch (contactType) {
      case "Owner":
        return "Owner Name";
      case "Builder":
        return "Builder Name";
      case "Dealer":
        return "Dealer Name";
      default:
        return "Name";
    }
  };

  // Get the placeholder text for the name field
  const getNameFieldPlaceholder = () => {
    switch (contactType) {
      case "Owner":
        return "Enter Owner Name";
      case "Builder":
        return "Enter Builder Name";
      case "Dealer":
        return "Enter Dealer Name";
      default:
        return "Select contact type first";
    }
  };

  // Handle multiple image uploads with progress
  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // Create upload queue items
    const newUploads = files.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      progress: 0,
      status: "uploading", // uploading, completed, error
      type: "image",
    }));

    setUploadQueue((prev) => [...prev, ...newUploads]);
    setIsUploading(true);

    // Upload files one by one
    for (const uploadItem of newUploads) {
      await uploadSingleFile(uploadItem);
    }

    setIsUploading(false);
  };

  // Upload single file with progress
  const uploadSingleFile = async (uploadItem) => {
    const formData = new FormData();
    formData.append("image", uploadItem.file);

    try {
      // Start progress simulation
      simulateProgress(uploadItem.id);

      // Use your existing file upload function
      const res = await HttpClientXml.fileUplode(
        "image-upload",
        "POST",
        formData,
      );

      if (res?.image) {
        // Update upload status to completed
        setUploadQueue((prev) =>
          prev.map((item) =>
            item.id === uploadItem.id
              ? { ...item, progress: 100, status: "completed" }
              : item,
          ),
        );

        // Add to images array
        setImages((prev) => [...prev, res.image]);

        toast.success(`${uploadItem.file.name} uploaded successfully!`);
      } else {
        throw new Error("Upload failed - No image URL in response");
      }
    } catch (error) {
      // Update upload status to error
      setUploadQueue((prev) =>
        prev.map((item) =>
          item.id === uploadItem.id ? { ...item, status: "error" } : item,
        ),
      );
      toast.error(`Failed to upload: ${uploadItem.file.name}`);
      console.error("Error uploading image:", error);
    }
  };

  // Simulate upload progress
  const simulateProgress = (fileId) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 20;
      if (progress >= 90) {
        progress = 90; // Hold at 90% until actual upload completes
        clearInterval(interval);
      } else {
        setUploadQueue((prev) =>
          prev.map((item) =>
            item.id === fileId
              ? { ...item, progress: Math.floor(progress) }
              : item,
          ),
        );
      }
    }, 200);
  };

  // Remove file from upload queue
  const handleRemoveUpload = (uploadId) => {
    setUploadQueue((prev) => prev.filter((item) => item.id !== uploadId));
  };

  // Remove uploaded image
  const handleRemoveImage = (imageToRemove) => {
    setImages((prev) => prev.filter((image) => image !== imageToRemove));
  };

  const handleAddFeature = () => {
    if (featureInput.trim() !== "") {
      setFeatures((prevFeatures) => [...prevFeatures, featureInput.trim()]);
      setFeatureInput("");
    } else {
      toast.error("Feature cannot be empty");
    }
  };

  const handleRemoveFeature = (featureToRemove) => {
    setFeatures((prevFeatures) =>
      prevFeatures.filter((feature) => feature !== featureToRemove),
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const floorPlusCount = floor?.split("+").length - 1;
    const pricePlusCount = price?.split("+").length - 1;

    if (floorPlusCount !== pricePlusCount) {
      toast.error("Floor count and price count is not matching");
      return;
    }

    if (!selectedPropertyType) {
      return toast.error("Property type should not be empty!");
    }

    // Check if any uploads are still in progress
    if (isUploading) {
      toast.error("Please wait for all files to finish uploading");
      return;
    }

    // Validate contact type and name
    if (contactType && !ownerName.trim()) {
      return toast.error(`Please enter ${getNameFieldLabel()}`);
    }

    if (!contactType && ownerName.trim()) {
      return toast.error("Please select contact type");
    }

    const matchedPropertyType = propertyType.find(
      (property) => property.propertyType === selectedPropertyType,
    );

    // Prepare contact data based on selected contact type
    let contactData = {};
    if (contactType && ownerName.trim()) {
      contactData = {
        contactType: contactType,
        name: ownerName.trim(),
      };
    }

    // EXACTLY match the Postman body structure with contact data
    const data = {
      propertyType: matchedPropertyType?._id,
      propertyFor,
      city: selectedCity,
      locality: selectedLocality,
      address: address || "",
      area: parseInt(area || 0),
      unit: unit || "",
      bhk: bhk || "",
      floor: floor || "",
      phoneNo: phoneNumber,
      // price: parseInt(price || 0),
      price: price || "",
      priceUnit: priceUnit || "",
      images,
      features,
      remarks: remarks || "",
      age: propertyAge || "",
      aptName: propertyName || "",
      date: startDate,
      newEntry: isNewEntry ? "$" : "",
      locationUrl: locationUrl || "",
      chosen: chosen || "",
      ...contactData, // Spread the contact data (will be empty if no contact type selected)
    };

    console.log("Property Data:", data);
    // return;
    try {
      const res = await HomeService.addProperty(data);
      if (res?.status) {
        toast.success("Property added successfully!");
        // Reset form
        setSelectedPropertyType("");
        setSelectedCity("");
        setSelectedLocality("");
        setAddress("");
        setArea("");
        setUnit("");
        setBhk("");
        setFloor("");
        setOwnerName("");
        setPhoneNumber("");
        setPrice("");
        setPriceUnit("");
        setImages([]);
        setFeatures([]);
        setRemarks("");
        setPropertyAge("");
        setPropertyName("");
        setStartDate("");
        setLocationUrl("");
        setUploadQueue([]);
        setIsNewEntry(false);
        setContactType(""); // Reset contact type
        setChosen("");
        navigate("/manage-property");
      } else {
        toast.error(res?.error || "Failed to add property");
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }
  };

  const handleNewEntryChange = (event) => {
    setIsNewEntry(event.target.checked);
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Add Property
          </h2>

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-9">
                  <div className="row">
                    <div className="col-md-6 mt-3">
                      <label>
                        Type<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedPropertyType}
                        onChange={(e) =>
                          setSelectedPropertyType(e.target.value)
                        }
                        required
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {propertyType.map((type) => (
                          <option key={type._id} value={type.propertyType}>
                            {type.propertyType}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        For<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={propertyFor}
                        onChange={(e) => setPropertyFor(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          --Select--
                        </option>
                        <option value="sale">Sale</option>
                        <option value="rent">Rent</option>
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        City<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                        required
                      >
                        <option value="">Select City</option>
                        {cities.map((city, key) => (
                          <option key={key} value={city._id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        Locality<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={selectedLocality}
                        onChange={(e) => setSelectedLocality(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {localities.map((item, key) => (
                          <option key={key} value={item._id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Apartment/Building Name</label>
                      <select
                        className="form-control"
                        value={propertyName}
                        onChange={(e) => setPropertyName(e.target.value)}
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {apartments.map((item, key) => (
                          <option key={key} value={item?.aptName}>
                            {item?.aptName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Age</label>
                      <input
                        type="text"
                        className="form-control"
                        value={propertyAge}
                        onChange={(e) => setPropertyAge(e.target.value)}
                        placeholder="Enter Age of the property"
                      />
                    </div>

                    {/* Contact Type Radio Buttons */}
                    <div className="col-md-12 mt-3">
                      <label>Contact Type</label>
                      <span className="text-danger">*</span>
                      <div
                        className="d-flex gap-4 mt-2"
                        style={{ gap: "15px" }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="contactType"
                            id="owner"
                            value="Owner"
                            checked={contactType === "Owner"}
                            onChange={() => handleContactTypeChange("Owner")}
                            required
                          />
                          <label className="form-check-label" htmlFor="owner">
                            Owner
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="contactType"
                            id="builder"
                            value="Builder"
                            checked={contactType === "Builder"}
                            onChange={() => handleContactTypeChange("Builder")}
                          />
                          <label className="form-check-label" htmlFor="builder">
                            Builder
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="contactType"
                            id="dealer"
                            value="Dealer"
                            checked={contactType === "Dealer"}
                            onChange={() => handleContactTypeChange("Dealer")}
                          />
                          <label className="form-check-label" htmlFor="dealer">
                            Dealer
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Dynamic Name Field based on Contact Type */}
                    <div className="col-md-6 mt-3">
                      <label>
                        {getNameFieldLabel()}
                        {contactType && <span className="text-danger">*</span>}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={ownerName}
                        onChange={(e) => setOwnerName(e.target.value)}
                        placeholder={getNameFieldPlaceholder()}
                        disabled={!contactType}
                        required={!!contactType}
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>
                        Phone Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="Enter Phone Number"
                        required
                      />
                    </div>

                    {/* Features Input */}
                    <div className="col-md-6 mt-3">
                      <label>Features</label>
                      <div className="d-flex">
                        <input
                          type="text"
                          className="form-control"
                          value={featureInput}
                          onChange={(e) => setFeatureInput(e.target.value)}
                          placeholder="Enter a feature"
                        />
                        <button
                          type="button"
                          className="btn btn-secondary ml-2"
                          onClick={handleAddFeature}
                        >
                          Add
                        </button>
                      </div>
                      <div className="mt-2">
                        {features.map((feature, index) => (
                          <span
                            key={index}
                            className="badge badge-primary mr-2"
                            style={{
                              display: "inline-block",
                              border: "solid 1px #85da4f",
                              backgroundColor: "transparent",
                              color: "#000",
                              padding: "8px 12px",
                              borderRadius: "13px",
                              fontSize: "14px",
                              margin: "5px",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                              transition: "all 0.3s ease",
                              fontWeight: "normal",
                            }}
                            onClick={() => handleRemoveFeature(feature)}
                          >
                            {feature}{" "}
                            <span
                              style={{
                                marginLeft: "5px",
                                fontWeight: "bold",
                                color: "#ff0000",
                              }}
                            >
                              ×
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Facing</label>
                      <select
                        className="form-control"
                        value={selectedFacing}
                        onChange={(e) => setSelectedFacing(e.target.value)}
                      >
                        <option value="">Select Facing</option>
                        {facings.map((facing, key) => (
                          <option key={key} value={facing._id}>
                            {facing.facing}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Address</label>
                      <input
                        type="text"
                        className="form-control"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Enter Address"
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Location URL (Google Maps)</label>
                      <input
                        type="url"
                        className="form-control"
                        value={locationUrl}
                        onChange={(e) => setLocationUrl(e.target.value)}
                        placeholder="https://maps.google.com/..."
                      />
                    </div>

                    <div className="col-md-4 mt-3">
                      <label>
                        Area<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={area}
                        // onChange={(e) => setArea(e.target.value)}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) {
                            setArea(Number(e?.target?.value));
                          }
                        }}
                        placeholder="Enter Area"
                        required
                      />
                    </div>
                    <div className="col-md-2 mt-3">
                      <label>
                        Unit<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        value={unit}
                        onChange={(e) => setUnit(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          --Select--
                        </option>
                        {propertyUnits()?.areaUnits.map((item, key) => (
                          <option key={key} value={item?.value}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>BHK</label>
                      <select
                        className="form-control"
                        value={bhk}
                        onChange={(e) => setBhk(e.target.value)}
                      >
                        <option value="" disabled>
                          --Select BHK--
                        </option>
                        {propertyUnits()?.bhkTypes.map((item, key) => (
                          <option key={key} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label>Floor</label>
                      <select
                        className="form-control"
                        value={floor}
                        onChange={(e) => setFloor(e.target.value)}
                      >
                        <option value="" disabled>
                          --Select--
                        </option>
                        {propertyUnits()?.floors.map((item, key) => (
                          <option key={key} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mt-3">
                      <label>{propertyFor === "rent" ? "Rent" : "Price"}</label>
                      <input
                        disabled={!floor}
                        type="text"
                        className="form-control"
                        value={price}
                        onChange={(e) => {
                          setPrice(e?.target?.value);
                        }}
                        placeholder="Enter Price"
                      />
                    </div>

                    <div className="col-md-2 mt-3">
                      <label>Unit</label>
                      <select
                        disabled={!floor}
                        className="form-control"
                        value={priceUnit}
                        onChange={(e) => setPriceUnit(e.target.value)}
                      >
                        <option value="" disabled>
                          --Select--
                        </option>
                        {propertyUnits()?.priceUnits.map((item, key) => (
                          <option key={key} value={item?.value}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="chosen">Is the Property Basic</label>
                      <select
                        id="chosen"
                        className="form-control"
                        value={chosen}
                        onChange={(e) => setChosen(e.target.value)}
                      >
                        <option value="">--Select--</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>

                    {/* Media Upload Section with Progress */}
                    <div className="col-md-12 mt-3">
                      <label>Upload Images + Videos</label>

                      {/* Upload Progress Section */}
                      {uploadQueue.length > 0 && (
                        <div className="mb-3">
                          <h6>Upload Progress:</h6>
                          <div className="upload-progress-container">
                            {uploadQueue.map((upload) => (
                              <UploadProgressBar
                                key={upload.id}
                                file={upload.file}
                                progress={upload.progress}
                                status={upload.status}
                                onRemove={() => handleRemoveUpload(upload.id)}
                              />
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Uploaded Images Preview */}
                      {images.length > 0 && (
                        <div className="mb-3">
                          <h6>Uploaded Media ({images.length}):</h6>
                          <div className="d-flex flex-wrap">
                            {images.map((img, index) => (
                              <div
                                key={index}
                                className="position-relative me-2 mb-2"
                              >
                                {img.match(/\.(jpeg|jpg|png|gif)$/i) ? (
                                  <img
                                    src={img}
                                    alt={`media-${index}`}
                                    width="320"
                                    height="240"
                                  />
                                ) : (
                                  <video width="320" height="240" controls>
                                    <source src={img} type="video/mp4" />
                                  </video>
                                )}
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute"
                                  style={{
                                    top: "2px",
                                    right: "2px",
                                    width: "20px",
                                    height: "20px",
                                    padding: "0",
                                    fontSize: "12px",
                                  }}
                                  onClick={() => handleRemoveImage(img)}
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      <input
                        type="file"
                        className="form-control"
                        onChange={handleImageUpload}
                        multiple
                        accept="image/*,video/*,.mkv"
                        disabled={isUploading}
                      />
                      <small className="text-muted">
                        {isUploading
                          ? "Uploading files... Please wait"
                          : "Select multiple images or videos to upload"}
                      </small>
                    </div>

                    <div className="col-md-12 mt-3">
                      <label>Remarks</label>
                      <textarea
                        className="form-control"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Enter remarks (if any)"
                      ></textarea>
                    </div>
                  </div>
                </div>

                {/* Right sidebar with staff selection and other fields */}
                <div className="col-lg-3">
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <label htmlFor="startDate">
                        List By<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-lg-12 mt-3">
                      <label>Telecaller Staff</label>
                      <select
                        className="form-control"
                        value={telecallerId}
                        onChange={(e) => setTelecallerId(e.target.value)}
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {telecallingStaff.map((item, key) => (
                          <option key={key} value={item._id}>
                            {`${item?.name} (${item?.designation?.name})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-lg-12 mt-3">
                      <label>Survey Staff</label>
                      <select
                        className="form-control"
                        value={surveyorId}
                        onChange={(e) => setSurveyorId(e.target.value)}
                      >
                        <option value="" disabled>
                          ---Select---
                        </option>
                        {surveyStaff.map((item, key) => (
                          <option key={key} value={item._id}>
                            {`${item?.name} (${item?.designation?.name})`}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-lg-12 mt-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isNewEntry}
                          onChange={handleNewEntryChange}
                        />
                        <label
                          className="form-check-label"
                          style={{ fontWeight: "bold" }}
                        >
                          New entry
                        </label>
                      </div>
                    </div>

                    <div className="col-lg-12 mt-3">
                      <button
                        type="submit"
                        style={{
                          background: isUploading
                            ? "#ccc"
                            : "rgb(133, 218, 79)",
                          borderRadius: "13px",
                          width: "inherit",
                        }}
                        className="btn mt-3"
                        disabled={isUploading}
                      >
                        {isUploading ? "Uploading..." : "Add Property"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddProperty;
